import gql from 'graphql-tag';

export default gql`
  fragment CompanyFragment on Company {
    _id
    name
    thumbnail {
      path
    }
    settings {
      isShowCompanyLogo
    }
    courseDirections {
      courseDirectionName
      _id
    }
  }
`;
